import React, { useState } from "react";
import "./toggle.css";
import styled from "styled-components";

const ButtonContainer = styled.div`
  display: flex;
  gap: 5px;
  padding: 3px;
  border-radius: 7px;
  border: 1px solid #d6d6d6;
`;
const Button = styled.button`
  border: none;
  height: 40px;
  flex: 1;
  border-radius: 7px;
  transition: all 0.16s ease-in-out;
`;
function ToggleSwitch({ toggled, onClick }) {
  const [isToggled, toggle] = useState(toggled);

  const callback = () => {
    toggle(!isToggled);
    onClick(!isToggled);
  };
  return (
		<ButtonContainer onClick={callback}>
			<Button
				className={isToggled ? "in-active-toggle" : "active-toggle"}
			>
				Automatic
			</Button>
			<Button
				className={!isToggled ? "in-active-toggle" : "active-toggle"}
			>
				Batch
			</Button>
		</ButtonContainer>
  );
}

export default ToggleSwitch;
